import React, { useState, useEffect } from "react";
import { makeStyles, useTheme, styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  CardHeader,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { useQuery, useMutation, useQueryClient } from "react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "form7";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-right"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const Form7InvStatusValidation = ({ handleClose, open, addProduct,FacilityId,YearId,MonthId, ...props }) => {
  let tblRef = null;
  // let YearId = 2022;
  // let MonthId = 6;
  const { isLoading, error, isError, data, refetch } = useQuery(
    ["form7", YearId, MonthId],
    api.getInvoiceStatusByMonth,{
      onSuccess: (isunpostinv) => {
      
      },
      // enabled: false,
      // refetchOnWindowFocus: false,
      // refetchOnmount: false,
      // refetchOnReconnect: false,
      // retry: false,
      // staleTime: 0,//1000 * 60 * 60 * 24,
    }
  );

  const [selectedProducts, setselectedProducts] = useState([]);

  const ProductColumns = [
    // { title: "id", field: "ItemNo", visible: false },
    // { title: "ItemNo", field: "ItemNo", visible: false },
    { title: DispensingLanguage[lan][menukey]['Sl#'],  formatter: "rownum", width:50, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: DispensingLanguage[lan][menukey]['Type'], field: "FormName", headerSort:false,hozAlign: "left" , headerHozAlign:"left", },
    { title: DispensingLanguage[lan][menukey]['Total Invoice'], field: "totalinv", width: 115, headerSort:false,hozAlign: "right" , headerHozAlign:"right", bottomCalc:"sum"},
    { title: DispensingLanguage[lan][menukey]['Updated'], field: "updated", width: 100, headerSort:false,hozAlign: "right" , headerHozAlign:"right", bottomCalc:"sum"},
    { title: DispensingLanguage[lan][menukey]['Not Updated'], field: "nonUpdated", width: 115, headerSort:false,hozAlign: "right" , headerHozAlign:"right", bottomCalc:"sum"},
    { title: DispensingLanguage[lan][menukey]['Cancelled'], field: "Cancel", width: 100, headerSort:false,hozAlign: "right" , headerHozAlign:"right", bottomCalc:"sum"},
  ];

  let selected = [];
  const ProdustDataItems = data?.map((item, index) => { 
    return item;
  });
  const SaveSelectedProducts = () => {
    if(tblRef.table.getSelectedData().length>0)
    console.log(tblRef.table.getSelectedData());
    setselectedProducts(tblRef.table.getSelectedData());
    
  };

  useEffect(() => { 
    if (tblRef == null) return;
    addProduct(selectedProducts);

}, [selectedProducts]); 


  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('Products')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('Products')}
        >
        {DispensingLanguage[lan][menukey]['Invoice Status']} 
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            ref={(r) => (tblRef = r)}
            options={{
              selectableRangeMode: 'click',
             }}
            selectable={true}
            columns={ProductColumns}
            data={ProdustDataItems}
            // height="300px"
            layout={"fitColumns"}

          />
        </DialogContent>
        <DialogActions>
          {/* <Button
            className="mr-2 float-left"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
           {DispensingLanguage[lan][menukey]['ADD']}  
          </Button> */}
          <Button
            autoFocus
            className="float-left"
            variant="contained" 
            onClick={() => handleClose('Products')}
          >
            {DispensingLanguage[lan][menukey]['Close']}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default Form7InvStatusValidation;
